import { useEffect, useState } from "react";

import { ISensor } from "../models/Sensors";
import { useMapEvents } from "react-leaflet";

export const useNearest = (sensor: ISensor): number => {
  const { nearest, position } = sensor;

  const [distance, setDistance] = useState<number>(0);

  const updateDistance = () => {
    setDistance(
      nearest === undefined
        ? Number.MAX_VALUE
        : map
            .latLngToLayerPoint(position)
            .distanceTo(map.latLngToLayerPoint(nearest.position))
    );
  };

  const map = useMapEvents({
    zoomend: updateDistance,
  });

  useEffect(updateDistance);

  return distance;
};
